module.exports = __webpack_public_path__ + "img/v2.9858fdd3.png";